






















































































import "./recurrence-setup.less";
import Vue from "vue";
import moment from "moment-timezone";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";

let _ = require("lodash");

export default Vue.extend({
  name: "RecurrenceSetup",
  components: {},
  props: {
    recurrence: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      weekdayOptions: [
        { value: "SUN", label: "SUN", disabled: false },
        { value: "MON", label: "MON", disabled: false },
        { value: "TUE", label: "TUE", disabled: false },
        { value: "WED", label: "WED", disabled: false },
        { value: "THU", label: "THU", disabled: false },
        { value: "FRI", label: "FRI", disabled: false },
        { value: "SAT", label: "SAT", disabled: false },
      ],
      monthlyOptions: [
        { value: "1", label: "Every first day of month", disabled: false },
        { value: "15", label: "Every 15th day of month", disabled: false },
        { value: "L", label: "Every last day of month", disabled: false },
      ],
      timeOptions: [
        { value: "00:00", label: "12:00 AM", disabled: false },
        { value: "00:30", label: "12:30 AM", disabled: false },
        { value: "01:00", label: "1:00 AM", disabled: false },
        { value: "01:30", label: "1:30 AM", disabled: false },
        { value: "02:00", label: "2:00 AM", disabled: false },
        { value: "02:30", label: "2:30 AM", disabled: false },
        { value: "03:00", label: "3:00 AM", disabled: false },
        { value: "03:30", label: "3:30 AM", disabled: false },
        { value: "04:00", label: "4:00 AM", disabled: false },
        { value: "04:30", label: "4:30 AM", disabled: false },
        { value: "05:00", label: "5:00 AM", disabled: false },
        { value: "05:30", label: "5:30 AM", disabled: false },
        { value: "06:00", label: "6:00 AM", disabled: false },
        { value: "06:30", label: "6:30 AM", disabled: false },
        { value: "07:00", label: "7:00 AM", disabled: false },
        { value: "07:30", label: "7:30 AM", disabled: false },
        { value: "08:00", label: "8:00 AM", disabled: false },
        { value: "08:30", label: "8:30 AM", disabled: false },
        { value: "09:00", label: "9:00 AM", disabled: false },
        { value: "09:30", label: "9:30 AM", disabled: false },
        { value: "10:00", label: "10:00 AM", disabled: false },
        { value: "10:30", label: "10:30 AM", disabled: false },
        { value: "11:00", label: "11:00 AM", disabled: false },
        { value: "11:30", label: "11:30 AM", disabled: false },
        { value: "12:00", label: "12:00 PM", disabled: false },
        { value: "12:30", label: "12:30 PM", disabled: false },
        { value: "13:00", label: "1:00 PM", disabled: false },
        { value: "13:30", label: "1:30 PM", disabled: false },
        { value: "14:00", label: "2:00 PM", disabled: false },
        { value: "14:30", label: "2:30 PM", disabled: false },
        { value: "15:00", label: "3:00 PM", disabled: false },
        { value: "15:30", label: "3:30 PM", disabled: false },
        { value: "16:00", label: "4:00 PM", disabled: false },
        { value: "16:30", label: "4:30 PM", disabled: false },
        { value: "17:00", label: "5:00 PM", disabled: false },
        { value: "17:30", label: "5:30 PM", disabled: false },
        { value: "18:00", label: "6:00 PM", disabled: false },
        { value: "18:30", label: "6:30 PM", disabled: false },
        { value: "19:00", label: "7:00 PM", disabled: false },
        { value: "19:30", label: "7:30 PM", disabled: false },
        { value: "20:00", label: "8:00 PM", disabled: false },
        { value: "20:30", label: "8:30 PM", disabled: false },
        { value: "21:00", label: "9:00 PM", disabled: false },
        { value: "21:30", label: "9:30 PM", disabled: false },
        { value: "22:00", label: "10:00 PM", disabled: false },
        { value: "22:30", label: "10:30 PM", disabled: false },
        { value: "23:00", label: "11:00 PM", disabled: false },
        { value: "23:30", label: "11:30 PM", disabled: false },
      ],
      durationOptions: [
        { value: 15, label: "15 minutes", disabled: false },
        { value: 30, label: "30 minutes", disabled: false },
        { value: 45, label: "45 minutes", disabled: false },
        { value: 60, label: "1 hour", disabled: false },
        { value: 120, label: "2 hours", disabled: false },
        { value: 180, label: "3 hours", disabled: false },
        { value: 240, label: "4 hours", disabled: false },
        { value: 300, label: "5 hours", disabled: false },
        { value: 360, label: "6 hours", disabled: false },
        { value: 420, label: "7 hours", disabled: false },
        { value: 480, label: "8 hours", disabled: false },
        { value: 540, label: "9 hours", disabled: false },
        { value: 600, label: "10 hours", disabled: false },
        { value: 660, label: "11 hours", disabled: false },
        { value: 720, label: "12 hours", disabled: false },
        { value: 1440, label: "1 day", disabled: false },
        { value: 2880, label: "2 days", disabled: false },
        { value: 4320, label: "3 day", disabled: false },
        { value: 5760, label: "4 day", disabled: false },
        { value: 7200, label: "5 day", disabled: false },
        { value: 8640, label: "6 day", disabled: false },
        { value: 10080, label: "1 week", disabled: false },
      ],

      currentRecurrence: {
        enabled: false,

        startTime: null,
        duration: "",
        startDate: null,
        endDate: null,
        timezoneName: "",

        timeframe: null,
        daily: null,
        weekly: [],
        monthly: null,
        dayIncrement: 1,
        dayIncrementStart: 1,
        daySpecific: [],
      },
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
    durationString(): any {
      let review = (this as any).currentReview;
      if (review.startDate && review.endDate) {
        let end = moment(review.endDate);
        let start = moment(review.startDate);

        if (review.timezoneName) {
          start = start.tz(review.timezoneName);
          end = end.tz(review.timezoneName);
        }

        return `${start.format("MM/DD/YYYY")} - ${end.format("MM/DD/YYYY z")}`;
      } else {
        return "";
      }
    },
    friendlyTimezoneName() {
      let review = (this as any).currentReview;
      return review.timezoneName ? moment.tz(review.timezoneName).format(" (Z z)") : "";
    },

    cronExpression() {
      let minute = 0;
      let hour = 0;
      if (this.currentRecurrence.startTime) {
        let startTime = moment(this.currentRecurrence.startTime, "HH:mm");
        hour = startTime.hour();
        minute = startTime.minute();
      }

      let weekday = "*";
      let monthday = "*";

      if (this.currentRecurrence.timeframe === "weekly") {
        weekday = this.currentRecurrence.weekly.length > 0 ? this.currentRecurrence.weekly.join(",") : "*";
        monthday = "?";
      } else if (this.currentRecurrence.timeframe === "daily" && this.currentRecurrence.daily === "weekday") {
        weekday = "1-5";
        monthday = "?";
      }

      if (this.currentRecurrence.timeframe === "monthly") {
        if (this.currentRecurrence.monthly === "dayIncrements") {
          monthday = `${this.currentRecurrence.dayIncrementStart}/${this.currentRecurrence.dayIncrement}`;
        } else if (this.currentRecurrence.monthly === "daySpecific") {
          monthday = this.currentRecurrence.daySpecific.length > 0 ? this.currentRecurrence.daySpecific.join(",") : "*";
        }
        weekday = "?";
      }

      let cron = `${minute} ${hour} ${monthday} * ${weekday}`;
      return cron;
    },

    rules() {
      let rules = {
        startTime: [
          {
            required: true,
            message: "Please select start Time",
          },
        ],
        duration: [
          {
            required: true,
            message: "Please select duration",
          },
        ],
        startDate: [
          {
            required: true,
            message: "Please pick a date",
          },
        ],
        endDate: [
          {
            required: true,
            message: "Please pick a date",
          },
        ],
        timeframe: [
          {
            required: true,
            message: "Please select Timeframe",
            trigger: "change",
          },
        ],
      };

      if (this.currentRecurrence.timeframe === "daily") {
        rules["daily"] = [
          {
            required: true,
            message: "Please select Pattern",
            trigger: "change",
          },
        ];
      }

      if (this.currentRecurrence.timeframe === "weekly") {
        rules["weekly"] = [
          {
            type: "array",
            required: true,
            message: "Please select Dates",
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("Please select Dates"));
              }
            },
            trigger: "change",
          },
        ];
      }

      if (this.currentRecurrence.timeframe === "monthly") {
        rules["monthly"] = [
          {
            required: true,
            message: "Please select Pattern",
            trigger: "change",
          },
        ];
      }

      return rules;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.currentRecurrence.enabled = this.recurrence.enabled;
        this.currentRecurrence.startTime = this.recurrence.startTime;
        this.currentRecurrence.duration = this.recurrence.duration;
        this.currentRecurrence.startDate = moment(this.recurrence.startDate).toDate();
        this.currentRecurrence.endDate = moment(this.recurrence.endDate).toDate();

        this.currentRecurrence.timeframe = this.recurrence.timeframe;
        this.currentRecurrence.daily = this.recurrence.daily;
        this.currentRecurrence.weekly = this.recurrence.weekly;
        this.currentRecurrence.monthly = this.recurrence.monthly;
        this.currentRecurrence.dayIncrement = this.recurrence.dayIncrement;
        this.currentRecurrence.dayIncrementStart = this.recurrence.dayIncrementStart;
        this.currentRecurrence.daySpecific = this.recurrence.daySpecific;
      }
    },
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.SetupForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          this.currentRecurrence.enabled = true;
          this.$emit("save", this.currentRecurrence);

          target.disabled = false;
        } else {
          target.disabled = false;
        }
      });
    },
    handleRemove() {
      this.currentRecurrence.enabled = false;
      this.$emit("save", this.currentRecurrence);
    },
    getPrettyDateString(date) {
      return moment(date).format("ddd M/D/YY");
    },
  },
});
